export default "skymp5-front/7f802c29bbf08eaf9d7ccd738034f943.png";